export default {
  All: 'all',
  Confirmed: 'confirmed',
  Unconfirmed: 'unconfirmed',
}
